module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm04_cont"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm05_for#ch00_fm05_for"
    }
  }, [_c('strong', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm06_intro#ch00_fm06_intro"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_note#ch00_fm07_note"
    }
  }, [_c('strong', [_vm._v("Publisher’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1: Everything You Ever Wanted to Ask Your Doctor About Acid Reflux")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Everything You Ever Wanted to Know About Food and Acid Reflux")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The 10 Food Steps to Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Waiting to Lose Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "id": "page_6",
      "title": "Link target outside of Sample"
    }
  }), _c('a', [_vm._v("Chapter 5: How to Have a Heartburn-Free Holiday")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Recipes You Can’t Live Without")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Restaurant Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_index#ch08_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09_abt#ch09_abt",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb104aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_cont.vue
// module id = 69
// module chunks = 0